import { render, staticRenderFns } from "./CampaignItemMetrics.vue?vue&type=template&id=2bd829cc&"
import script from "./CampaignItemMetrics.vue?vue&type=script&lang=js&"
export * from "./CampaignItemMetrics.vue?vue&type=script&lang=js&"
import style0 from "./CampaignItemMetrics.vue?vue&type=style&index=0&id=2bd829cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports